export default {
  baseURL: "https://rgift.co.il/api",
  version: "1.3.2",
};
